"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spacing = void 0;
var spacing = {
  xSmall: {
    padding: {
      xxs: '0.5rem',
      xs: '0.55rem',
      sm: '0.6rem',
      md: '0.65rem',
      lg: '0.7rem',
      xl: '0.75rem'
    }
  },
  small: {
    padding: {
      xxs: '1rem',
      xs: '1.1rem',
      sm: '1.2rem',
      md: '1.3rem',
      lg: '1.4rem',
      xl: '1.5rem'
    }
  },
  // normal is default
  normal: {
    padding: {
      xxs: '1.5rem',
      xs: '1.6rem',
      sm: '1.7rem',
      md: '1.8rem',
      lg: '1.9rem',
      xl: '2rem'
    }
  },
  large: {
    padding: {
      xxs: '2rem',
      xs: '2.2rem',
      sm: '2.4rem',
      md: '2.6rem',
      lg: '2.8rem',
      xl: '3rem'
    }
  },
  xLarge: {
    padding: {
      xxs: '3rem',
      xs: '3.2rem',
      sm: '3.4rem',
      md: '3.6rem',
      lg: '3.8rem',
      xl: '4rem'
    }
  }
};
exports.spacing = spacing;